import { render, staticRenderFns } from "./glzy.vue?vue&type=template&id=e1309804&scoped=true&"
import script from "./glzy.vue?vue&type=script&lang=js&"
export * from "./glzy.vue?vue&type=script&lang=js&"
import style0 from "./glzy.vue?vue&type=style&index=0&id=e1309804&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1309804",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1309804')) {
      api.createRecord('e1309804', component.options)
    } else {
      api.reload('e1309804', component.options)
    }
    module.hot.accept("./glzy.vue?vue&type=template&id=e1309804&scoped=true&", function () {
      api.rerender('e1309804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/glzy.vue"
export default component.exports